import React from 'react';
import { Text } from '@moda/om';
import { RestAddressAttributesData } from '../../../hooks/useAddress';

interface Props {
  data: Omit<RestAddressAttributesData, '__typename' | 'source'>;
}

export const ShippingAddressInfoBlock: React.FC<Props> = ({ data }) => (
  <Text data-testid="shippingAddressInfoBlock">
    <div>
      {data.firstName} {data.lastName}
    </div>
    <div>{data.addressLine1}</div>
    <div>{data.addressLine2}</div>
    <div>
      {data.city}, {data.state}, {data.postalCode}, {data.countryCode}
    </div>
    <div>{data.phone}</div>
  </Text>
);
